import * as React from 'react';
type Props = {
  className?: string;
};
export function LunchCategory({ className }: Props) {
  return (
    <svg
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-lunchCategory"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.033 62.2365C116.033 31.5084 78.3989 40.2611 63.8938 15.8C49.3885 -8.66128 10.4321 2.16698 2.58993 26.1415C-1.33143 52.0406 14.3534 46.6791 19.0114 83.4265C21.8695 105.974 29.1335 119.105 63.8938 115.417C98.6541 111.727 116.033 92.9647 116.033 62.2365Z"
        fill="#D6E4EE"
      />
      <path
        d="M92.7077 75.7876C91.7829 77.4912 89.9576 78.5864 89.3491 78.9271C85.9662 80.8011 81.9505 80.363 78.1539 79.9006C60.8986 77.8319 56.2745 76.4204 48.9002 76.8341C45.0062 77.0531 41.672 77.2235 37.9483 78.8054C35.6363 79.7789 34.8818 80.5821 32.7158 80.9228C29.6249 81.4339 25.5605 80.7524 23.3945 78.6351C22.7374 77.978 22.275 77.2478 21.9829 76.469C18.5513 78.6107 16.5557 81.0688 16.5557 83.6973C16.5557 91.7773 35.0765 98.3241 57.9294 98.3241C80.7823 98.3241 99.3032 91.7773 99.3032 83.6973C99.3032 80.7768 96.8694 78.051 92.7077 75.7876Z"
        fill="white"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M90.7126 69.3252C90.0312 68.7168 88.8136 67.8295 85.601 66.9777C85.455 67.1238 85.309 67.2454 85.163 67.3671C85.163 67.3671 85.163 67.3671 85.1386 67.3915C84.9926 67.5131 84.8466 67.6348 84.7249 67.7565C84.5058 67.9269 84.3355 68.0729 84.1408 68.2189C83.8487 68.438 83.6054 68.6083 83.4593 68.7057C83.4107 68.7544 83.362 68.7787 83.3376 68.803C83.3133 68.803 83.289 68.8274 83.289 68.8274C83.2403 68.876 83.1673 68.9491 83.0699 69.0221C83.0699 69.0221 83.0213 69.0464 82.9969 69.0707C82.8022 69.2168 82.5588 69.3628 82.2668 69.5332C82.2181 69.5332 82.1938 69.5818 82.1451 69.6062C81.9991 69.6792 81.8531 69.7765 81.707 69.8495C81.4637 69.9712 81.2446 70.0929 81.0012 70.2146C81.0012 70.2146 80.7579 70.3363 80.6362 70.385C80.5388 70.4336 80.4171 70.4823 80.3198 70.531C80.2711 70.531 80.2468 70.5797 80.1981 70.5797C80.1494 70.604 80.0764 70.6284 80.0277 70.6527C79.9791 70.6527 79.9304 70.7014 79.9061 70.7014C79.8574 70.7014 79.8087 70.75 79.7844 70.75C79.7357 70.75 79.687 70.7987 79.6627 70.7987C79.6383 70.7987 79.614 70.8231 79.5653 70.8474C79.5167 70.8474 79.468 70.8961 79.4436 70.8961C79.4436 70.8961 79.4436 70.8961 79.4193 70.8961C79.2733 70.9691 79.1759 70.9934 79.1759 70.9934C78.7135 71.1881 78.2268 71.3585 77.7644 71.4802C76.7909 71.7479 75.8174 71.9426 74.9169 72.0399C74.2354 72.1129 73.6026 72.1616 73.0429 72.1859C72.8482 72.1859 72.6778 72.1859 72.5075 72.1859C72.3614 72.1859 72.2154 72.1859 72.0694 72.1859C72.0207 72.1859 71.9964 72.1859 71.9477 72.1859C71.8503 72.1859 71.753 72.1859 71.68 72.1859C71.6556 72.1859 71.607 72.1859 71.5826 72.1859C71.3636 72.1859 71.1932 72.1859 71.0715 72.1859C71.0715 72.1859 71.0472 72.1859 71.0229 72.1859C70.9742 72.1859 70.9499 72.1859 70.9255 72.1859C70.9012 72.1859 70.8768 72.1859 70.8768 72.1859C70.5605 72.1616 70.2441 72.1129 69.952 72.0643C69.3436 71.9669 68.7595 71.8452 68.2241 71.6992C65.693 71.0421 63.7703 69.9226 62.8698 69.3141C62.8211 69.2898 62.7968 69.2655 62.7725 69.2411C62.6994 69.1924 62.6264 69.1438 62.5778 69.0951C62.5534 69.0951 62.5291 69.0464 62.5047 69.0464C62.4561 69.0221 62.4074 68.9734 62.3831 68.9491C62.3831 68.9491 62.3587 68.9491 62.3344 68.9247C62.31 68.9247 62.2857 68.876 62.2857 68.876C61.945 68.6813 61.6286 68.438 61.3122 68.1703C60.7281 67.7078 60.1683 67.1481 59.6329 66.5883C59.6086 66.564 59.5599 66.5153 59.5356 66.491C59.3165 66.2476 59.1218 66.0286 58.9028 65.7852C58.8541 65.7365 58.8298 65.7122 58.8054 65.6635C58.6107 65.4445 58.4404 65.2254 58.27 65.0064C58.2457 64.982 58.2213 64.9334 58.197 64.909C57.905 64.544 57.6616 64.2033 57.4669 63.9355C57.4425 63.8869 57.4182 63.8625 57.3939 63.8382C57.3452 63.7652 57.2965 63.7165 57.2722 63.6435C57.2722 63.6191 57.2235 63.5948 57.2235 63.5461C57.1992 63.4975 57.1748 63.4731 57.1505 63.4245C57.1505 63.4245 57.1505 63.4001 57.1262 63.3758C57.1262 63.3514 57.1018 63.3271 57.1018 63.3271L57.1748 63.1567C57.1748 63.1567 57.0531 63.1567 56.9801 63.1567C56.4934 63.8869 56.0796 64.4466 56.0796 64.4466C55.3252 65.6392 53.3295 67.4158 53.3295 67.4158C50.8227 69.6792 48.0239 70.5797 48.0239 70.5797C44.7627 71.8452 41.4771 71.2855 41.4771 71.2855C36.7557 70.7987 33.0077 67.1724 31.5718 65.5905C30.1115 65.5418 28.2375 65.6392 26.5096 66.5153C22.3965 68.6327 19.8411 74.8387 23.5891 78.5137C25.7551 80.6311 29.8195 81.3125 32.9103 80.8014C35.0764 80.4364 35.8065 79.6576 38.1429 78.6841C41.8665 77.1021 45.2008 76.9318 49.0948 76.7127C56.469 76.299 61.0932 77.7106 78.3485 79.7793C82.1451 80.2417 86.1608 80.6797 89.5437 78.8058C90.3468 78.3677 93.316 76.5667 93.4377 73.7679C93.5351 71.5532 91.4184 69.958 90.7126 69.3252Z"
        fill="white"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M46.9043 71.0176C47.8048 71.7234 50.4089 72.0154 52.7453 76.9072"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M78.5429 79.6818C78.5429 79.6818 79.1757 78.2216 72.9453 72.2832"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M89.446 48.481C92.5855 49.6005 97.38 52.1803 96.3335 57.5832C95.0436 64.276 85.26 54.9061 81.7067 56.0743C79.8084 56.707 79.3216 59.0921 77.7153 60.3333C75.2086 62.2803 73.0425 61.1365 70.4628 59.7979C66.1307 57.5588 61.7499 52.813 56.9554 55.3441C52.8424 57.5345 51.1144 63.2051 46.1009 61.1851C42.3773 59.6762 39.7002 53.8109 35.3681 55.0034C32.0338 55.9282 28.797 61.3068 25.0977 58.8974"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M26.3143 66.6367C22.2012 68.7541 19.6458 74.9601 23.3938 78.6351C25.5598 80.7525 29.6242 81.4339 32.715 80.9228"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M53.6699 67.0747C53.6699 67.0747 64.5975 72.2829 65.5953 78.27"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M23.5996 69.3252C23.5996 69.3252 34.3779 71.7079 41.2996 78.1752"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M88.5 78.1752C88.5 78.1752 86.9749 74.3514 81.125 69.3252"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M78.1291 79.9009C60.8738 77.8322 56.2497 76.4206 48.8754 76.8343C44.9814 77.0534 41.6472 77.2237 37.9235 78.8057C35.6115 79.7792 34.857 80.5823 32.691 80.923C31.3524 81.1421 29.8435 81.1177 28.3589 80.8744C28.3102 83.6245 29.4784 86.4477 31.8148 86.8857C38.2886 88.1026 39.4811 87.9079 45.5412 87.4212C50.7494 87.0074 56.1523 87.0804 61.3849 87.0804C65.3275 87.0804 69.2215 86.9831 73.1642 87.0318C77.1312 87.0561 79.7353 86.764 83.3616 86.6424C85.1869 86.5937 88.3265 85.9366 88.8376 82.1399C88.9836 80.9474 88.9836 79.9495 88.8376 79.1221C85.552 80.704 81.731 80.3146 78.1047 79.8765L78.1291 79.9009Z"
        fill="white"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M27.1426 55.5633L31.2556 62.4021L58.3189 61.3556L67.3725 69.46L83.2405 67.4157L87.816 60.4064L83.5569 53.6406L27.1426 55.5633Z"
        fill="white"
      />
      <path
        d="M81.7066 56.0501C80.3437 56.4882 79.4919 57.9728 79.4919 57.9728C79.1511 58.5569 79.3215 59.36 79.8813 59.7494L82.8261 61.8668C83.3615 62.2562 84.0186 62.8159 84.2863 63.108V64.4222C84.0673 64.7142 83.4102 65.2497 82.8504 65.6391C82.8504 65.6391 78.3723 68.5839 76.3523 68.1945L75.3301 67.9998C75.3301 67.6104 75.2328 66.7343 75.1598 66.0528L74.8677 62.5482C74.8434 61.8668 74.2836 61.1853 73.6265 61.0149L72.0446 60.5282C71.4361 60.2361 70.8764 60.5282 70.8034 61.2096L70.2923 65.6634C70.2193 66.3449 70.0489 67.1723 69.9272 67.5374L69.3675 67.8538L68.8077 68.1702C68.4426 68.0972 67.6638 67.7564 67.0797 67.4157C67.0797 67.4157 62.4313 64.7873 61.7742 62.7916L61.4578 61.7694C61.7985 61.5747 62.5043 61.088 63.064 60.6986L66.3739 58.5082C66.958 58.1431 66.958 57.559 66.3739 57.194C66.3739 57.194 61.7011 54.0788 58.6833 54.6872L59.2187 54.5898C59.7785 54.5898 60.1192 55.1253 59.9488 55.7824C59.9488 55.7824 58.951 59.6764 57.3204 62.4509L57.15 62.7186C56.9553 63.0106 56.9067 63.4244 57.0527 63.6434L57.1987 63.8381C58.3912 65.5661 62.8207 71.4557 70.779 72.2102C77.5449 72.843 84.0186 69.5087 87.8153 64.3248C89.1295 62.5239 90.0787 60.2361 90.0787 60.2361C90.3464 59.6034 90.0787 58.8489 89.4702 58.5082C89.4702 58.5082 83.6292 55.3686 81.7309 55.9771L81.7066 56.0501Z"
        fill="white"
      />
      <path
        d="M81.7066 56.0501C80.3437 56.4882 79.4919 57.9728 79.4919 57.9728C79.1511 58.5569 79.3215 59.36 79.8813 59.7494L82.8261 61.8668C83.3615 62.2562 84.0186 62.8159 84.2863 63.108V64.4222C84.0673 64.7142 83.4102 65.2497 82.8504 65.6391C82.8504 65.6391 78.3723 68.5839 76.3523 68.1945L75.3301 67.9998C75.3301 67.6104 75.2328 66.7343 75.1598 66.0528L74.8677 62.5482C74.8434 61.8668 74.2836 61.1853 73.6265 61.0149L72.0446 60.5282C71.4361 60.2361 70.8764 60.5282 70.8034 61.2096L70.2923 65.6634C70.2193 66.3449 70.0489 67.1723 69.9272 67.5374L69.3675 67.8538L68.8077 68.1702C68.4426 68.0972 67.6638 67.7564 67.0797 67.4157C67.0797 67.4157 62.4313 64.7873 61.7742 62.7916L61.4578 61.7694C61.7985 61.5747 62.5043 61.088 63.064 60.6986L66.3739 58.5082C66.958 58.1431 66.958 57.559 66.3739 57.194C66.3739 57.194 61.7011 54.0788 58.6833 54.6872L59.2187 54.5898C59.7785 54.5898 60.1192 55.1253 59.9488 55.7824C59.9488 55.7824 58.951 59.6764 57.3204 62.4509L57.15 62.7186C56.9553 63.0106 56.9067 63.4244 57.0527 63.6434L57.1987 63.8381C58.3912 65.5661 62.8207 71.4557 70.779 72.2102C77.5449 72.843 84.0186 69.5087 87.8153 64.3248C89.1295 62.5239 90.0787 60.2361 90.0787 60.2361C90.3464 59.6034 90.0787 58.8489 89.4702 58.5082C89.4702 58.5082 83.6292 55.3686 81.7309 55.9771L81.7066 56.0501Z"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M60.0954 19.2762C60.6551 18.9355 60.7525 18.2054 60.3144 17.6943C59.8763 17.1832 59.779 16.3801 60.0711 15.8933C60.3631 15.4066 60.2414 15.0415 59.7547 15.0415C59.2679 15.0415 58.9028 14.8711 58.9028 14.6765C58.9028 14.4818 58.8055 14.0924 58.6838 13.8246C58.5621 13.5569 57.8563 13.3379 57.7833 13.3379C57.7103 13.3379 57.3939 13.4352 57.1262 13.5569C56.8585 13.6786 56.6395 14.4818 56.6395 14.6765C56.6395 14.8711 56.2501 15.0415 55.7876 15.0415C55.3252 15.0415 55.2035 15.4309 55.5199 15.8933C55.8363 16.3557 55.6903 17.1832 55.1792 17.7186C54.6681 18.254 54.6681 18.9598 55.1792 19.3006C55.6903 19.6413 55.958 20.4688 55.812 21.1259C55.666 21.783 56.4204 22.3427 57.5643 22.3427C58.7082 22.3427 59.4869 21.783 59.3409 21.1259C59.1949 20.4688 59.5356 19.617 60.0954 19.2519V19.2762Z"
        fill="white"
      />
      <path
        d="M60.0954 19.2762C60.6552 18.9355 60.7525 18.2054 60.3144 17.6943C59.8763 17.1832 59.779 16.3801 60.0711 15.8933C60.3631 15.4066 60.2414 15.0415 59.7547 15.0415C59.2679 15.0415 58.9028 14.8711 58.9028 14.6765C58.9028 14.4818 58.8055 14.0924 58.6838 13.8246C58.5621 13.5569 57.8563 13.3379 57.7833 13.3379C57.7103 13.3379 57.3939 13.4352 57.1262 13.5569C56.8585 13.6786 56.6395 14.4818 56.6395 14.6765C56.6395 14.8711 56.2501 15.0415 55.7876 15.0415C55.3252 15.0415 55.2035 15.4309 55.5199 15.8933C55.8363 16.3557 55.6903 17.1832 55.1792 17.7186C54.6681 18.254 54.6681 18.9598 55.1792 19.3006C55.6903 19.6413 55.958 20.4688 55.812 21.1259C55.666 21.783 56.4204 22.3427 57.5643 22.3427C58.7082 22.3427 59.4869 21.783 59.3409 21.1259C59.1949 20.4688 59.5356 19.6169 60.0954 19.2519V19.2762Z"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M27.5557 59.433C27.5557 59.433 28.7969 64.3005 34.5405 68.6082C34.5405 68.6082 40.3572 73.8895 48.9483 70.2145C48.9483 70.2145 53.1831 68.5839 56.493 63.6677C56.493 63.6677 58.3183 61.7451 60.1923 54.5898"
        fill="white"
      />
      <path
        d="M27.5557 59.433C27.5557 59.433 28.7969 64.3005 34.5405 68.6082C34.5405 68.6082 40.3572 73.8895 48.9483 70.2145C48.9483 70.2145 53.1831 68.5839 56.493 63.6677C56.493 63.6677 58.3183 61.7451 60.1923 54.5898"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M39.9195 56.1958C39.9195 56.1958 33.9082 59.457 33.4701 60.0655C33.4701 60.0655 32.4966 60.8199 33.6891 62.2072C33.6891 62.2072 35.9769 64.6409 39.2138 66.4662C39.2138 66.4662 40.82 66.7826 40.9904 65.3954L41.5015 57.5344"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M44.5439 60.2605C44.5439 60.2605 44.7386 64.8603 44.982 65.7121C44.982 65.7121 45.2254 66.6612 46.4179 66.5639C46.4179 66.5639 48.511 66.3205 52.3563 63.0836C52.3563 63.0836 53.5732 61.5017 51.6505 60.0171"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M88.1805 48.4812C91.32 49.6007 97.3801 52.1805 96.3335 57.5834C95.0437 64.2762 85.26 54.9063 81.7067 56.0745C79.8084 56.7073 79.3216 59.0924 77.7154 60.3336C75.2086 62.2806 73.0426 61.1367 70.4628 59.7981C66.1307 57.5591 61.75 52.8133 56.9555 55.3444C52.8424 57.5348 51.1145 63.2054 46.1009 61.1854C42.3773 59.6765 39.7002 53.8111 35.3681 55.0037C32.0339 55.9285 28.797 61.3071 25.0977 58.8977C19.427 55.174 28.7483 48.7489 31.036 47.6294"
        fill="white"
      />
      <path
        d="M88.1805 48.4812C91.32 49.6007 97.3801 52.1805 96.3335 57.5834C95.0437 64.2762 85.26 54.9063 81.7067 56.0745C79.8084 56.7073 79.3216 59.0924 77.7154 60.3336C75.2086 62.2806 73.0426 61.1367 70.4628 59.7981C66.1307 57.5591 61.75 52.8133 56.9555 55.3444C52.8424 57.5348 51.1145 63.2054 46.1009 61.1854C42.3773 59.6765 39.7002 53.8111 35.3681 55.0037C32.0339 55.9285 28.797 61.3071 25.0977 58.8977C19.427 55.174 28.7483 48.7489 31.036 47.6294"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M30.8661 41.1553L29.7466 45.3413C29.1381 47.6534 33.0078 49.6004 38.362 49.7221L80.685 50.5495C86.0392 50.6469 89.7872 49.0406 89.0084 46.9476L87.5968 43.1509"
        fill="white"
      />
      <path
        d="M30.8661 41.1553L29.7466 45.3413C29.1381 47.6534 33.0078 49.6004 38.362 49.7221L80.685 50.5495C86.0392 50.6469 89.7872 49.0406 89.0084 46.9476L87.5968 43.1509"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M88.1567 42.4454C88.9112 38.7705 74.333 33.3676 71.8993 32.3941C61.3125 28.1593 48.2676 26.9668 37.9972 32.8321C35.9041 34.0247 32.1075 36.1177 30.8663 38.6245C29.5521 41.2529 32.1805 41.91 34.1762 42.1777C36.7316 42.5428 39.3601 42.4941 41.9155 42.6158C50.0442 43.0539 58.1973 43.4676 66.326 43.7353C70.5851 43.8814 74.8441 43.9787 79.1032 43.9544C80.4418 43.9544 87.7187 44.5385 88.1324 42.4454H88.1567Z"
        fill="white"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M57.71 32.0287V22.3667"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M56.2012 55.7822C56.4445 55.6119 56.6879 55.4658 56.9556 55.3198"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M55.4951 56.3175C55.4951 56.3175 55.7142 56.1472 55.8358 56.0498C55.7142 56.1472 55.5925 56.2202 55.4951 56.3175Z"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M56.9561 55.3441C57.2238 55.1981 57.4671 55.1008 57.7349 55.0034C57.4671 55.1008 57.2238 55.2225 56.9561 55.3441Z"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M58.538 54.7603C58.3189 54.8089 58.0999 54.8576 57.8809 54.955C58.0999 54.8819 58.3189 54.8089 58.538 54.7603Z"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M54.8623 56.8531C54.8623 56.8531 54.9597 56.7557 55.0083 56.707C54.9597 56.7557 54.911 56.8044 54.8623 56.8531Z"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M67.348 38.5028C67.2506 39.0869 66.7395 39.4033 66.4962 39.5493C65.547 40.1334 64.0381 40.0604 63.4783 38.9895C63.454 38.9165 63.1376 38.3324 63.308 37.651C63.6 36.5314 64.9872 35.9473 66.0338 36.4097C66.7639 36.7261 67.494 37.6753 67.348 38.5271V38.5028Z"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M51.4554 37.8944C51.3581 38.4785 50.847 38.7949 50.6036 38.9409C49.6544 39.525 48.1455 39.452 47.5857 38.3811C47.5614 38.3081 47.245 37.724 47.4154 37.0426C47.7074 35.923 49.0947 35.3389 50.1412 35.8013C50.8713 36.1177 51.6014 37.0669 51.4554 37.9187V37.8944Z"
        stroke="#2E364E"
        strokeMiterlimit={10}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}
